import { prop } from '@lib/style/theme';
import { cleanProps } from '@lib/utils';
import { css } from 'styled-components';
import { unitStrict } from '../unit';

export interface PaddingProps {
    p?: number | string;
    padding?: number | string;
}

export const padding = (defaultValue?: number | string): any => css`
    & {
        padding: ${prop(['p', 'padding'], defaultValue, unitStrict)};
    }
`;

padding.clean = (props): any => cleanProps(props, ['p', 'padding']);
